<div class="map-model">
    <div class="find-outer">
        <h4>Find Location</h4>
        <div class="close-icon">
            <img src="assets/images/export-close.svg" alt="close" (click)="cancel()" alt="Close" />
        </div>
    </div>

    <form [formGroup]="parkingForm">
        <div class="p-inputgroup">
            <input type="text" pInputText placeholder="Enter your location" formControlName="locAddress" mapAutoComplete
                (mapSearch)="searchAutoCompleteLocation($event)" />
        </div>

        <div class="map1 custom-map12" #mapElement></div>
        <div class="map-btn">
            <p-button label="Set Location" (onClick)="selectLocation()"></p-button>
        </div>
    </form>
</div>